import {ArcCurve, Vector4} from 'three'

import type {BrandedDividerParams} from '../../../../components/WebGLContext/WebGLContext.types'
import BaseConpilot from './BaseCopilot'

export default class Copilot0 extends BaseConpilot {
  constructor(params: BrandedDividerParams, rectData: Vector4) {
    super(params, rectData)

    const scale = 0.35
    this.group.scale.set(scale, scale, scale)
  }

  override createPath() {
    //
    // 1) Create a 3D path (Curve)

    this.offsetPos.set(0, 2.6)
    this.curve = new ArcCurve(0, 0, 5, Math.PI * 1.8, Math.PI * 1.2, true)

    this.createTube()

    //
    // 2) Visualize the path (Line helper)
    //
    // const divisions = 200;
    // const curveLineGeom = new BufferGeometry().setFromPoints(this.curve.getPoints(divisions));
    // const curveLineMat = new LineBasicMaterial({ color: 0xff00ff });
    // const curveLine = new Line(curveLineGeom, curveLineMat);
    // this.group.add(curveLine);
  }

  override createTl() {
    this.tl
      .to(
        this.progress,
        {
          x: 1,
          ease: 'expo.out',
          duration: 3.0,
        },
        0,
      )
      .to(
        this.progress,
        {
          y: 1,
          ease: 'expo.out',
          duration: 3,
        },
        0,
      )
      .to(
        this.progress,
        {
          z: 1,
          ease: 'expo.out',
          duration: 3,
        },
        0,
      )
      .to(
        this.progress,
        {
          w: 1,
          ease: 'power2.out',
          duration: 3,
        },
        0,
      )

    super.createTl()
  }

  override moveOnArc() {
    const t01 = this.progress.x
    const p2 = this.curve.getPointAt(t01) // Vector2
    const tan2 = this.curve.getTangentAt(t01) // Vector2

    // position on XY plane
    this.group2.position.set(p2.x + this.offsetPos.x, p2.y + this.offsetPos.y, 0)

    // rotate to face tangent direction
    const angle = Math.atan2(tan2.y, tan2.x)
    this.group2.rotation.set(-0.3 + (1 - this.progress.y) * 4.0, 0.2, angle - Math.PI * 0.5)

    this.group2.scale.set(t01, t01, t01) // scale up from 0 to 1;

    if (this.tube) {
      this.tube.rotation.z = (1 - t01) * 0.6 * Math.PI
    }
  }

  override update(scrollProgress: number) {
    super.update(scrollProgress)
  }
}
